import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadTypes, TrackActionTypes } from 'types';
import Services from '../../services';
import { trackCompleted } from './actions';

function* doPostCollect(request: PayloadTypes) {
  try {
    yield call(Services.track.collectService, request.payload);
    yield put(trackCompleted());
  } catch (error) {
    console.error(error);
  }
}

export function* onPostCollectSaga() {
  yield takeLatest(TrackActionTypes.SUBMIT_EVENT, doPostCollect);
}

function* trackSagas() {
  yield all([call(onPostCollectSaga)]);
}
export default trackSagas;
